export default __webpack_public_path__ + "static/media/trustvault.8df4eb47.jpeg";